import { Component, Input, OnInit } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { ChargeBoxService } from "src/app/_services/chargebox/chargebox.service";
import { StationService } from "src/app/_services/station.service";
import { UserInfoService } from "src/app/_services/userInfo.service";
import { MenuRouteID } from "src/app/components/header/menu-item/nav-item";
import { Permission } from "src/app/util/enums/permission.enum";

@Component({
  selector: 'telio-device-amenities',
  templateUrl: './device-amenities.component.html',
  styleUrls: ['./device-amenities.component.scss']
})
export class DeviceAmenitiesComponent implements OnInit {
  @Input() stationdetail: any;
  @Input() stationId: any;
  amenitiesList = [];
  @Input() routeID = null;

  constructor(readonly router: Router, private stationService: StationService, readonly chargeboxService: ChargeBoxService,
    readonly userInfoService: UserInfoService) { }

  ngOnInit(): void {
    if (this.stationdetail && this.stationdetail.amenities)
      this.LoadAmenities();
    else
      this.getstationlistbyid(this.stationId);
  }

  LoadAmenities() {
    let amenities = this.stationdetail.amenities.filter(x => x.enable == true);
    let cat = amenities.map((item) => item.category).filter((value, index, self) => self.indexOf(value) === index);
    cat.forEach(x => {
      let list = amenities.filter(a => x == a.category).map(x => x.title);
      this.amenitiesList.push({ category: x, amenities: list });
    })
  }

  getstationlistbyid(id) {
    this.stationService.getstationlistbyid(id).subscribe(
      (data: any) => {
        this.stationdetail = data;
        this.LoadAmenities();
      },
      error => {
      }
    );
  }

  editAmenities() {
      let objToSend: NavigationExtras = {
        queryParams: {
          "routedName": 'deviceAmenities',
          "stationId": this.stationId,
          "vendorId": this.stationdetail.vendorId
        },
        skipLocationChange: false
      };
  
      this.router.navigate(["/dashboard/add-station", { routeID: MenuRouteID.STATIONS }], objToSend);
  }

  getIcon(amenity) {
    return this.chargeboxService.getAmenitiesIcon(amenity); 
  }

  checkPermission(): boolean {
    return this.userInfoService.filterPermission(this.routeID, Permission.UPDATE)
  }
}